import { MEDIA_TYPE, type FeedPost } from '../api/types'

/**
 * The "social sanity" rules shared by the settings modal, the intro modal and
 * the feed hold: slider ranges, the payable-view thresholds the backend
 * serves with the app settings, and the per-browser feed tab. Mirrors the
 * mobile clients' SocialSanity helpers.
 */

/** Slider ceilings (seconds), the same values the backend clamps to. */
export const SANITY_IMAGE_MAX = 10
export const SANITY_VIDEO_MAX = 30

/** app_settings keys of the payable-view thresholds (seconds). */
export const SANITY_IMAGE_THRESHOLD_KEY = 'AdMobMinimumImageWatchTime'
export const SANITY_VIDEO_THRESHOLD_KEY = 'AdMobMinimumVideoWatchTime'
export const SANITY_IMAGE_THRESHOLD_DEFAULT = 3
export const SANITY_VIDEO_THRESHOLD_DEFAULT = 10

export function isPayable(seconds: number, threshold: number): boolean {
  return seconds >= threshold
}

/** How long the feed holds on this post (0 = no hold). */
export function holdSecondsFor(post: FeedPost, imageSeconds: number, videoSeconds: number): number {
  return post.mediaType === MEDIA_TYPE.video ? videoSeconds : imageSeconds
}

// ---------------------------------------------------------------- feed tab

export type FeedMode = 'trending' | 'forYou'

/** Backend FeedNature: 0 = global, 1 = followed accounts only. */
export function feedNature(mode: FeedMode): number {
  return mode === 'forYou' ? 1 : 0
}

const FEED_MODE_KEY = 'app.feedMode'

export function readFeedMode(): FeedMode {
  try {
    return localStorage.getItem(FEED_MODE_KEY) === 'forYou' ? 'forYou' : 'trending'
  } catch {
    return 'trending'
  }
}

export function storeFeedMode(mode: FeedMode): void {
  try {
    localStorage.setItem(FEED_MODE_KEY, mode)
  } catch {
    // Private mode or storage disabled: the choice simply lasts one session.
  }
}

// ---------------------------------------------------------------- intro

const INTRO_SEEN_KEY = 'app.socialSanityIntroSeen'

export function socialSanityIntroSeen(): boolean {
  try {
    return localStorage.getItem(INTRO_SEEN_KEY) === '1'
  } catch {
    return true
  }
}

export function markSocialSanityIntroSeen(): void {
  try {
    localStorage.setItem(INTRO_SEEN_KEY, '1')
  } catch {
    // Nothing to do: the popup returns next time, which is the safe side.
  }
}

// ---------------------------------------------------------------- my circle intro

const MY_CIRCLE_INTRO_SEEN_KEY = 'app.myCircleIntroSeen'

/** The "My circle" explainer (first visit to the tab) was slid through and closed. */
export function myCircleIntroSeen(): boolean {
  try {
    return localStorage.getItem(MY_CIRCLE_INTRO_SEEN_KEY) === '1'
  } catch {
    return true
  }
}

export function markMyCircleIntroSeen(): void {
  try {
    localStorage.setItem(MY_CIRCLE_INTRO_SEEN_KEY, '1')
  } catch {
    // Nothing to do: the popup returns next time, which is the safe side.
  }
}
